import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentFilters } from './document.service';
import { environment } from '../../environments/environment';
import { FileService } from '../shared/services/file.service';

@Injectable({
  providedIn: 'root'
})
export class SdrfDocumentService {
  private http = inject(HttpClient);
  private fileService = inject(FileService);
  private apiUrl = `${environment.basePath}/api/admin/public-documents`;

  getDocuments(filters: DocumentFilters): Observable<any> {
    const params: any = {
      page: filters.page,
      size: filters.size
    };

    if (filters.unitId) {
      params.unitId = filters.unitId;
    }

    if (filters.documentName) {
      params.documentName = filters.documentName;
    }

    return this.http.get(this.apiUrl, { params });
  }

  getDocumentById(id: string): Observable<any> {
    return this.http.get(`${environment.basePath}/api/public-documents/${id}`);
  }

  uploadDocument(file: File, unitId?: string | null, purpose?: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);

    if (unitId) {
      formData.append('unitId', unitId);
    }

    if (purpose) {
      formData.append('purpose', purpose);
    }

    return this.http.post(this.apiUrl, formData);
  }

  updateDocument(
    id: string,
    data: { name: string; purpose: string }
  ): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, {
      documentName: data.name,
      purpose: data.purpose
    });
  }

  inactiveDocument(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}/active`);
  }

  activateDocument(id: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/active`, {});
  }

  getDownloadUrl(doc: any): string {
    const mediaId = doc?.media?.id || doc?.mediaId;
    const filename = doc?.media?.filename || doc?.documentName || doc?.fileName;

    if (!mediaId || !filename) {
      throw new Error('Document does not have media information');
    }

    return this.fileService.getPublicUrl(mediaId, filename);
  }

  downloadDocument(doc: any): Observable<Blob> {
    const mediaId = doc?.media?.id || doc?.mediaId;
    const filename = doc?.media?.filename || doc?.documentName || doc?.fileName;

    if (!mediaId || !filename) {
      throw new Error('Document does not have media information');
    }

    return this.fileService.downloadFile(mediaId, filename);
  }

  deleteDocument(documentId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${documentId}`);
  }
}